// Scrolling Button Component - handles ScrollTrigger rotation animation
// Import from shared GSAP module (ScrollTrigger already registered)
import { gsap, ScrollTrigger } from '../gsap-config.js';

class ScrollingButton extends HTMLElement {
    constructor() {
        super();
        this.scrollTrigger = null;
    }

    connectedCallback() {
        this.initialize();
    }

    disconnectedCallback() {
        // Clean up ScrollTrigger
        if (this.scrollTrigger) {
            this.scrollTrigger.kill();
            this.scrollTrigger = null;
        }
    }

    initialize() {
        // Add base class for CSS compatibility
        this.classList.add('tt-scrolling-btn');

        // Find the spinner SVG element
        const scrBtnSvg = this.querySelector(".scr-btn-spinner");
        if (scrBtnSvg) {
            // Create ScrollTrigger animation for rotation
            this.scrollTrigger = gsap.from(scrBtnSvg, {
                rotate: 240,
                ease: "none",
                scrollTrigger: {
                    trigger: scrBtnSvg,
                    start: "-40% bottom",
                    end: "120% top",
                    scrub: true,
                    markers: false,
                },
            });
        }
    }
}

customElements.define('scrolling-button', ScrollingButton);


